import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import RegisterForm from "../RegisterForm";
import { useGetHomeQuery } from "@/store/rest_api";
import { useAuth } from "@/hooks/useAuth";

const Register = () => {
  const { isAuthenticated } = useAuth();
  const { data: userData } = useGetHomeQuery(undefined, { skip: !isAuthenticated });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // After registering, return to where they came from (e.g. an invitation link).
  const redirect = searchParams.get("redirect");

  useEffect(() => {
    if (userData) {
      navigate(redirect || "/dashboard");
    }
  }, [userData, navigate, redirect]);

  return (
    <div className="min-h-svh w-full flex items-center justify-center bg-muted text-foreground p-6">
      <RegisterForm />
    </div>
  );
};

Register.propTypes = {};

export default Register;
